export const PASSWORD_MIN_CODE_POINTS = 8;
export const PASSWORD_MAX_CODE_POINTS = 128;
export const PASSWORD_MAX_UTF8_BYTES = 1_024;

export const PASSWORD_LENGTH_ERROR_MESSAGE =
  "パスワードは8〜128文字、UTF-8で1024バイト以内にしてください。";
export const PASSWORD_DENYLIST_ERROR_MESSAGE =
  "よく使われるパスワードのため使用できません。別のパスワードを入力してください。";
export const PASSWORD_LENGTH_HINT = "8〜128文字。空白とUnicodeを使用できます。";

export function isPasswordLengthValid(password: string): boolean {
  const codePoints = [...password].length;
  const utf8Bytes = new TextEncoder().encode(password).byteLength;
  return codePoints >= PASSWORD_MIN_CODE_POINTS &&
    codePoints <= PASSWORD_MAX_CODE_POINTS &&
    utf8Bytes <= PASSWORD_MAX_UTF8_BYTES;
}
